var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPoint16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#point_16_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 16.002A8 8 0 1 0 8 0a8 8 0 0 0 0 16.002Z",
  fill: "#2D91FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.38 4.35c0-.289.235-.522.523-.522h2.651c.811 0 1.5.276 2.067.828.56.552.84 1.227.84 2.03 0 .803-.28 1.48-.84 2.03-.568.552-1.257.827-2.067.827H7.06v1.876a.84.84 0 0 1-1.678 0V4.35Zm1.68 3.625h1.494c.357 0 .653-.124.887-.372.235-.248.352-.553.352-.918 0-.366-.117-.681-.352-.924a1.182 1.182 0 0 0-.887-.365H7.06V7.975Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "point_16_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgPoint16;